export const FETCH_BASKET_PENDING = "FETCH_BASKET_PENDING";
export const FETCH_BASKET_REJECTED = "FETCH_BASKET_REJECTED";
export const FETCH_BASKET_FULFILLED = "FETCH_BASKET_FULFILLED";
export const FETCH_VOUCHERCODE_REJECTED = "FETCH_VOUCHERCODE_REJECTED";
export const FETCH_CUSTOMER_FULFILLED = "FETCH_CUSTOMER_FULFILLED";
export const REMOVE_BASKET_ITEMS = "REMOVE_BASKET_ITEMS";
export const COMPLETE_CALL_CENTER_FULFILLED = "COMPLETE_CALL_CENTER_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/basket.js